module.exports = __webpack_public_path__ + "img/upmood_logo.ee0466f6.svg";